import { ENDPOINTS } from '../../network/endpoints';
import axios from 'axios';

/** @implements {import('../../../contracts/IKnowledgebaseRepository').IKnowledgebaseRepository} */
export class KnowledgebaseRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getDocuments(options = {}) {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.BASE, {
      params: options,
    });
  }

  async createDocumentFromUrl(urlData) {
    return this.client.post(ENDPOINTS.KNOWLEDGE_BASE.URL, urlData);
  }

  async createDocumentFromText(textData) {
    return this.client.post(ENDPOINTS.KNOWLEDGE_BASE.TEXT, textData);
  }

  async createDocumentFromFile(fileData) {
    // Uses external ElevenLabs API directly for file uploads
    const apiKey = localStorage.getItem('PROVIDER_API_KEY');
    const response = await axios.post('https://api.elevenlabs.io/v1/convai/knowledge-base/file', fileData, {
      headers: {
        'xi-api-key': apiKey,
        'Content-Type': 'multipart/form-data',
      },
      timeout: 60000,
    });
    return response.data;
  }

  async getRagIndexOverview() {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.RAG_INDEX);
  }

  async getDocumentById(documentId) {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.BY_ID(documentId));
  }

  async updateDocument(documentId, updateData) {
    return this.client.patch(ENDPOINTS.KNOWLEDGE_BASE.BY_ID(documentId), updateData);
  }

  async deleteDocument(documentId) {
    return this.client.delete(ENDPOINTS.KNOWLEDGE_BASE.BY_ID(documentId));
  }

  async getDocumentRagIndexes(documentId) {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.DOCUMENT_RAG(documentId));
  }

  async computeRagIndex(documentId, ragConfig = {}) {
    return this.client.post(ENDPOINTS.KNOWLEDGE_BASE.DOCUMENT_RAG(documentId), ragConfig);
  }

  async deleteRagIndex(documentId, ragIndexId) {
    return this.client.delete(ENDPOINTS.KNOWLEDGE_BASE.DOCUMENT_RAG_BY_ID(documentId, ragIndexId));
  }

  async getDependentAgents(documentId) {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.DEPENDENT_AGENTS(documentId));
  }

  async getDocumentContent(documentId) {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.CONTENT(documentId));
  }

  async getDocumentChunk(documentId, chunkId) {
    return this.client.get(ENDPOINTS.KNOWLEDGE_BASE.CHUNK(documentId, chunkId));
  }

  async getKnowledgeBaseSize(agentId) {
    return this.client.get(ENDPOINTS.AGENTS.KNOWLEDGE_BASE_SIZE(agentId));
  }
}
